





















































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, onMounted, toRefs, watch } from '@vue/composition-api';
import { get } from 'lodash';
// Import utils ------------------------------------------------------------------------------------
import {
  useFormFieldAutoComplete,
  useFormObserver,
  cleanFieldValue,
  useForm,
  useFormFieldDate
} from '@/utils/forms.utils';
import { useI18n } from '@/utils/i18n.utils';
// Import components -------------------------------------------------------------------------------
import FormFieldAutoComplete from '@/components/forms/FormFieldAutoComplete.vue';
import FormFieldDate from '@/components/forms/FormFieldDate.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'PatientPathologyForm',
  props: {
    pathologies: {
      type: Object,
      default: null
    },
    pathology: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormFieldAutoComplete,
    FormFieldDate
  },
  setup(properties, { root, emit }) {
    const rObserver = useFormObserver();

    const { pathologies, pathology } = toRefs(properties);

    const { dateFormat, currentLang } = useI18n();

    const pathologyType = useFormFieldAutoComplete<string>({
      key: 'pathology-type',
      value: null!,
      items: pathologies.value.pathologyTypes,
      rules: {
        required: true
      }
    });

    const pathologyItems = computed(() => {
      return pathologies.value.pathologies.filter((pathology: any) => {
        return pathology.pathologyTypeCuid === pathologyType.value;
      });
    });

    const pathologyValue = useFormFieldAutoComplete<string>({
      key: 'pathology',
      value: null!,
      items: pathologyItems,
      rules: {
        required: true
      }
    });

    const sinceDate = useFormFieldDate({
      key: 'sinceDate',
      value: '',
      rules: {
        required: false
      },
      datePicker: {
        type: 'month',
        scrollable: true,
        'no-title': true,
        dense: true,
        max: root.$moment().subtract(0, 'years').toISOString()
      }
    });

    const { submit } = useForm(
      {
        pathologyType,
        pathologyValue,
        sinceDate
      },
      rObserver,
      () => {
        emit('submit', getFields());
      }
    );

    function getFields() {
      const pathology: any = pathologyValue.items.find(
        (pathologyItem: any) => pathologyItem.cuid === pathologyValue.value
      );
      return {
        pathologyPatched: {
          pathology: pathologyItems.value.find(
            (pathologyItem: any) => pathologyItem.cuid === pathologyValue.value
          ),
          sinceDate: cleanFieldValue(sinceDate)
            ? root
                .$moment(root.$moment(`${cleanFieldValue(sinceDate)}-01 12:00:00`).format())
                .format(dateFormat.value)
            : null
        },
        pathologyName: pathology.name
      };
    }

    onMounted(() => {
      if (pathology.value) {
        pathologyType.value = get(pathology.value, 'pathology.pathologyTypeCuid');
        pathologyValue.value = get(pathology.value, 'pathology.cuid');
        if (pathology.value.sinceDate) {
          sinceDate.value = (root.$moment(get(pathology.value, 'sinceDate')) as any).format(dateFormat.value);
        }
      }

      watch(
        () => pathologyType.value,
        () => {
          pathologyValue.value = null!;
        }
      );
    });

    return {
      // References
      rObserver,
      // Form fields
      pathologyType,
      pathologyValue,
      sinceDate,
      // Methods
      submit
    };
  }
});
